import React, { useState } from "react";
import "./Setting.css";
import { Link, useNavigate } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import { FiSettings } from "react-icons/fi";
import Alert from "../../Components/Alert/Alert";
import { MdLogout } from "react-icons/md";
import { useAuth } from "../../AuthContext";

export default function Setting() {
  const navigate = useNavigate()
  const [showAlert, setShowAlert] = useState(false);
  const { handleLogout } = useAuth()

  const alertModalHandler = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
  };

  const logoutHandler = () => {
    navigate("/login");
    localStorage.removeItem("token");
    localStorage.removeItem("userPhoneNumber");
    handleLogout()
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">
            تنظیمات
            <FiSettings className="settingIcon" />
          </div>
          <ul className="settingList">
            <li
              className="settingItem horizontalBorder"
              onClick={alertModalHandler}
            >
              <img src="/images/notification.svg" alt="notification icon" />
              اعلان ها
            </li>
            <li className="settingItem horizontalBorder">
              <Link to="/editProfile" className="link">
                <img src="/images/key.svg" alt="key icon" />
                حساب کاربری
              </Link>
            </li>
            <li className="settingItem horizontalBorder">
              <Link to="/guide" className="link">
                <img src="/images/help.svg" alt="help icon" />
                راهنما
              </Link>
            </li>
            <li
              className="settingItem horizontalBorder"
              onClick={alertModalHandler}
            >
              <img src="/images/times.svg" alt="times icon" />
              حذف حساب کاربری
            </li>
            <li className="settingItem horizontalBorder" onClick={logoutHandler}>
              <MdLogout className="settingLogoutIcon" />
              خروج از حساب کاربری
            </li>
          </ul>
          <Alert alertText="به زودی" showAlert={showAlert} />
        </div>
      </div>
    </div>
  );
}
